import './kernels/backend_webgl';
import './kernels/backend_cpu';
import { BrowserUtil } from './browser_util';
import * as environment from './environment';
import { Environment } from './environment';
import * as io from './io/io';
import * as serialization from './serialization';
import * as test_util from './test_util';
import * as util from './util';
import { version } from './version';
import * as webgl from './webgl';
export { AdadeltaOptimizer } from './optimizers/adadelta_optimizer';
export { AdagradOptimizer } from './optimizers/adagrad_optimizer';
export { AdamOptimizer } from './optimizers/adam_optimizer';
export { AdamaxOptimizer } from './optimizers/adamax_optimizer';
export { MomentumOptimizer } from './optimizers/momentum_optimizer';
export { Optimizer } from './optimizers/optimizer';
export { RMSPropOptimizer } from './optimizers/rmsprop_optimizer';
export { SGDOptimizer } from './optimizers/sgd_optimizer';
export { Tensor, TensorBuffer, variable, Variable } from './tensor';
export { Rank } from './types';
export * from './ops/ops';
export { Reduction } from './ops/loss_ops';
export * from './train';
export * from './globals';
export { ENV, Environment } from './environment';
export var setBackend = Environment.setBackend;
export var getBackend = Environment.getBackend;
export var disposeVariables = Environment.disposeVariables;
export var memory = Environment.memory;
export { version as version_core };
export { doc } from './doc';
export var nextFrame = BrowserUtil.nextFrame;
export { environment, io, serialization, test_util, util, webgl };
//# sourceMappingURL=index.js.map